import ResponsiveHeader from './ResponsiveHeader'

export default ResponsiveHeader
